var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "builderDialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogOpen,
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "40%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogOpen = $event
            },
          },
        },
        [_vm._v("\n    " + _vm._s(_vm.dialogBuilderText) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }